import { createFileRoute } from "@tanstack/react-router"
import { AvatarAdGeneratorPageWrapper } from "./-AvatarAdGeneratorPage"

export const Route = createFileRoute("/tools/avatar-ad-generator")({
  component: AvatarAdGeneratorPageWrapper,
})
